import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'utils/react';
import { authCheck } from 'store/modules/user';

class AuthHeartbeat extends React.Component {
  static propTypes = {
    onCheck: PropTypes.func.isRequired,
    interval: PropTypes.number,
    redirectOnFail: PropTypes.bool,
  };

  static defaultProps = {
    interval: 120000,
    redirectOnFail: true,
  };

  UNSAFE_componentWillMount() {
    this.installInterval();
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    // The only piece of the interval that doesn't check `this.props` every interval is the interval time, so
    // we'll set up a new interval time if that prop changes
    if (newProps.interval !== this.props.interval || !this.intervalId) {
      this.clearInterval();
      this.installInterval();
    }
  }

  componentWillUnmount() {
    this.clearInterval();
  }

  intervalId = null;

  installInterval() {
    // Don't install this heartbeat on the server
    if (typeof window === 'undefined') {
      return;
    }

    const { interval } = this.props;

    this.intervalId = setInterval(async () => {
      const { onCheck, redirectOnFail } = this.props;

      try {
        await onCheck();
      } catch (err) {
        if (redirectOnFail) {
          // Redirect through the server so the user can go through the auth flow again
          window.location = '/admin';
        }
      }
    }, interval);
  }

  clearInterval() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  render() {
    // We have nothing to render for this guy
    return false;
  }
}

export default compose(
  connect(null, { onCheck: authCheck }),
)(AuthHeartbeat);
